import { DirectSalesNavigationLineData } from 'components/common/types/DirectSalesHeader';
import { Line } from '../types/Deal.types';
import { DirectSalesLockStatusOption } from '../types/DirectSalesCampaign.types';

export const getIsDirectSalesLineLocked = (line: Line | DirectSalesNavigationLineData): boolean => {
  return 'lockState' in line && !!line.lockState && line.lockState.status === DirectSalesLockStatusOption.LOCKED;
};
